export default __webpack_public_path__ + "static/media/Homologación de Prestaciones.0af7afa6.xlsx";